import { InMemoryCache, makeVar } from '@apollo/client';
export const insuranceEstimate = makeVar(true);
const cache = new InMemoryCache({
    typePolicies: {
        insurance: {
            fields: {
                insuranceOption: {
                    read() {
                        return insuranceEstimate();
                    },
                },
            },
        },
    },
});
export default cache;
//# sourceMappingURL=cache.js.map